// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_2cMZk7_u","label":"_1KRqNNoA","dollarSign":"_3Kbe04Xl","input":"_1VH-5Vgd"};